var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"slide"}},[(!_vm.loading)?_c('UiBrackets',{attrs:{"matches":_vm.matches}}):_vm._e()],1),_c('transition',{attrs:{"name":"slide"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('QlashLoader')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }